import { Component, Vue } from 'vue-facing-decorator'
import router from '@/router/index'
import { createHabitacion, findAllHabitaciones, updateHabitacion } from "@/firebase/firestore/fsServices"
import { deleteMessages } from '@/firebase/realtimeDB/services'
import { useToast } from "primevue/usetoast";
import Swal from 'sweetalert2'
import Cookies from 'js-cookie';

@Component
export default class Habitaciones extends Vue {
    habitaciones?: any[];
    toast = useToast();
    cookies: any;
    profileLvl: string;

    showCrearHabitacionModal: boolean = false;
    nuevoNombreHabitacion: string = "";
    crearHabitacionSubmitting: boolean = false;
    crearHabitacionError: string = "";
    
    // Variables para el modal de cambio de habitación
    showCambiarHabitacionModal: boolean = false;
    habitacionesLibres: any[] = [];
    habitacionSeleccionada: any = null;
    pacienteACambiar: any = null;

    beforeMount() {
        this.profileLvl = Cookies.get("CurrentUserProfileLvl");
    }

    mounted(): void {
        findAllHabitaciones().then((data) => {
            this.habitaciones = data;
        });
    }

    abrirModalCrearHabitacion() {
        this.crearHabitacionError = "";
        this.nuevoNombreHabitacion = "";
        this.showCrearHabitacionModal = true;
    }

    cerrarModalCrearHabitacion() {
        if (this.crearHabitacionSubmitting) {
            return;
        }
        this.showCrearHabitacionModal = false;
        this.crearHabitacionError = "";
        this.nuevoNombreHabitacion = "";
    }

    async guardarNuevaHabitacion() {
        const nombre = (this.nuevoNombreHabitacion || "").trim();
        if (!nombre) {
            this.crearHabitacionError = "El nombre de la habitación es obligatorio";
            return;
        }

        const nombreLower = nombre.toLowerCase();
        if (this.habitaciones?.some(h => String(h?.habitacion || "").trim().toLowerCase() === nombreLower)) {
            this.crearHabitacionError = "Ya existe una habitación con ese nombre";
            return;
        }

        this.crearHabitacionSubmitting = true;
        this.crearHabitacionError = "";

        const idHabitacion = this.generarIdHabitacion();
        const habitacionNueva: any = {
            idHabitacion,
            habitacion: nombre,
            status: 0,
            nombrePaciente: null,
            edad: null,
            direccion: null,
            tel: null,
            correo: null,
            fechaNacim: null,
            sexo: null,
            estadoCivil: null,
            fechaingreso: null,
            diagnosticoi: null,
            diagnosticoe: null,
            nombreEnfermero: null,
            medicoTratante: null,
            isalergia: false,
            alergias: [],
            isdiabetico: false,
            ishipertenso: false,
            fechaing: null,
            fechaegr: null
        };

        try {
            const result: any = await createHabitacion(habitacionNueva);
            if (!result || result.code !== 200) {
                throw result?.error || new Error("Error al guardar");
            }

            this.toast.add({
                severity: 'success',
                summary: 'Proceso exitoso',
                detail: 'La habitación se creó correctamente',
                life: 3600
            });

            this.cerrarModalCrearHabitacion();
            this.habitaciones = await findAllHabitaciones();

        } catch (error: any) {
            const msg = error?.message ? String(error.message) : "No se pudo crear la habitación";
            this.crearHabitacionError = msg;
            this.toast.add({
                severity: 'error',
                summary: 'Error',
                detail: msg,
                life: 5000
            });
        } finally {
            this.crearHabitacionSubmitting = false;
        }
    }

    private generarIdHabitacion(): string {
        const c: any = (globalThis as any).crypto;
        if (c && typeof c.randomUUID === "function") {
            return c.randomUUID();
        }
        return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    }

    formatHabitacion(tipo: number) {
        switch (tipo) {
            case 0:
                return "Libre"
            case 1:
                return "Ocupada"
            default:
                break;
        }
    }

    editHabitacion(uid: string) {
        router.push('/editHabitacion/' + uid);
    }

    editExtrasHabitacion(uidHabitacion: string, habitacion: string) {
        router.push('/extrasHabitacion/' + uidHabitacion + '&' + habitacion);
    }

    cambiarHabitacion(habitacionActual: any) {
        // Filtrar habitaciones libres (status = 0)
        this.habitacionesLibres = this.habitaciones?.filter(h => h.status === 0) || [];
        
        if (this.habitacionesLibres.length === 0) {
            this.toast.add({ 
                severity: 'warn', 
                summary: 'Sin habitaciones disponibles', 
                detail: 'No hay habitaciones libres disponibles para el cambio', 
                life: 3600 
            });
            return;
        }
        
        this.pacienteACambiar = habitacionActual;
        this.showCambiarHabitacionModal = true;
    }

    async confirmarCambioHabitacion() {
        if (!this.habitacionSeleccionada || !this.pacienteACambiar) {
            this.toast.add({ 
                severity: 'warn', 
                summary: 'Selección requerida', 
                detail: 'Debe seleccionar una habitación destino', 
                life: 3600 
            });
            return;
        }

        // Validar que el paciente tenga datos mínimos
        if (!this.validarDatosPaciente(this.pacienteACambiar)) {
            this.toast.add({ 
                severity: 'warn', 
                summary: 'Datos incompletos', 
                detail: 'El paciente no tiene los datos mínimos requeridos para el cambio', 
                life: 3600 
            });
            return;
        }

        console.log('Iniciando cambio de habitación...');
        console.log('Habitación origen:', this.pacienteACambiar);
        console.log('Habitación destino:', this.habitacionSeleccionada);

        // Guardar referencias antes de limpiar las variables
        const habitacionOrigenNombre = this.pacienteACambiar.habitacion;
        const habitacionDestinoNombre = this.habitacionSeleccionada.habitacion;

        try {
            // Transferir datos del paciente a la nueva habitación
            const nuevaHabitacion = { ...this.habitacionSeleccionada };
            this.transferirDatosPaciente(this.pacienteACambiar, nuevaHabitacion);
            
            console.log('Nueva habitación con datos transferidos:', nuevaHabitacion);

            // Limpiar la habitación anterior
            const habitacionAnterior = this.resetHabitacion({ ...this.pacienteACambiar });
            
            console.log('Habitación anterior limpia:', habitacionAnterior);

            // Actualizar ambas habitaciones en secuencia para evitar conflictos
            console.log('Actualizando nueva habitación...');
            await updateHabitacion(nuevaHabitacion);
            
            console.log('Actualizando habitación anterior...');
            await updateHabitacion(habitacionAnterior);

            // Actualizar la lista local
            this.actualizarListaLocal(nuevaHabitacion, habitacionAnterior);

            console.log('Cambio de habitación completado exitosamente');
            
            // Cerrar modal y limpiar variables
            this.cerrarModalCambio();

            this.toast.add({ 
                severity: 'success', 
                summary: 'Cambio exitoso', 
                detail: `Paciente transferido de ${habitacionOrigenNombre} a ${habitacionDestinoNombre}`, 
                life: 3600 
            });

        } catch (error) {
            console.error('Error detallado al cambiar habitación:', error);
            
            // Recargar datos para asegurar consistencia
            findAllHabitaciones().then((data) => {
                this.habitaciones = data;
            });
            
            this.toast.add({ 
                severity: 'info', 
                summary: 'Cambio realizado', 
                detail: 'El cambio se realizó pero hubo un problema con la sincronización. Los datos se han actualizado.', 
                life: 5000 
            });
            
            // Cerrar modal
            this.cerrarModalCambio();
        }
    }

    private validarDatosPaciente(habitacion: any): boolean {
        // Validar que al menos tenga nombre del paciente
        return habitacion && habitacion.nombrePaciente && habitacion.nombrePaciente.trim().length > 0;
    }

    private transferirDatosPaciente(habitacionOrigen: any, habitacionDestino: any) {
        // Transferir todos los datos del paciente, manejando valores nulos y arrays
        habitacionDestino.nombrePaciente = habitacionOrigen.nombrePaciente || null;
        habitacionDestino.edad = habitacionOrigen.edad || null;
        habitacionDestino.direccion = habitacionOrigen.direccion || null;
        habitacionDestino.tel = habitacionOrigen.tel || null;
        habitacionDestino.correo = habitacionOrigen.correo || null;
        habitacionDestino.fechaNacim = habitacionOrigen.fechaNacim || null;
        habitacionDestino.sexo = habitacionOrigen.sexo || null;
        habitacionDestino.estadoCivil = habitacionOrigen.estadoCivil || null;
        habitacionDestino.fechaingreso = habitacionOrigen.fechaingreso || null;
        habitacionDestino.fechaegr = habitacionOrigen.fechaegr || null;
        habitacionDestino.fechaing = habitacionOrigen.fechaing || null;
        habitacionDestino.nombreEnfermero = habitacionOrigen.nombreEnfermero || null;
        
        // Manejar diagnósticos (puede ser array o objeto)
        if (habitacionOrigen.diagnosticoi) {
            if (Array.isArray(habitacionOrigen.diagnosticoi)) {
                habitacionDestino.diagnosticoi = [...habitacionOrigen.diagnosticoi];
            } else {
                habitacionDestino.diagnosticoi = habitacionOrigen.diagnosticoi;
            }
        } else {
            habitacionDestino.diagnosticoi = null;
        }
        
        habitacionDestino.diagnosticoe = habitacionOrigen.diagnosticoe || null;
        
        // Manejar médicos tratantes (puede ser array o objeto)
        if (habitacionOrigen.medicoTratante) {
            if (Array.isArray(habitacionOrigen.medicoTratante)) {
                habitacionDestino.medicoTratante = [...habitacionOrigen.medicoTratante];
            } else {
                habitacionDestino.medicoTratante = habitacionOrigen.medicoTratante;
            }
        } else {
            habitacionDestino.medicoTratante = null;
        }
        
        // Campos booleanos
        habitacionDestino.isalergia = habitacionOrigen.isalergia || false;
        habitacionDestino.isdiabetico = habitacionOrigen.isdiabetico || false;
        habitacionDestino.ishipertenso = habitacionOrigen.ishipertenso || false;
        
        // Manejar alergias (array)
        if (habitacionOrigen.alergias && Array.isArray(habitacionOrigen.alergias)) {
            habitacionDestino.alergias = [...habitacionOrigen.alergias];
        } else {
            habitacionDestino.alergias = [];
        }
        
        // Marcar como ocupada
        habitacionDestino.status = 1;
    }

    private actualizarListaLocal(nuevaHabitacion: any, habitacionAnterior: any) {
        if (this.habitaciones) {
            // Actualizar habitación destino
            const indexDestino = this.habitaciones.findIndex(h => h.idHabitacion === nuevaHabitacion.idHabitacion);
            if (indexDestino !== -1) {
                this.habitaciones[indexDestino] = nuevaHabitacion;
            }

            // Actualizar habitación origen
            const indexOrigen = this.habitaciones.findIndex(h => h.idHabitacion === habitacionAnterior.idHabitacion);
            if (indexOrigen !== -1) {
                this.habitaciones[indexOrigen] = habitacionAnterior;
            }
        }
    }

    cerrarModalCambio() {
        this.showCambiarHabitacionModal = false;
        this.habitacionSeleccionada = null;
        this.pacienteACambiar = null;
        this.habitacionesLibres = [];
    }

    liberarHabitacion(habitacion: any) {
        Swal.fire({
            title: '¿Desea liberar la: ' + habitacion.habitacion + '?',
            text: 'Esto limpiará la información del paciente',
            icon: 'warning',
            showDenyButton: true,
            confirmButtonText: 'Si',
            denyButtonText: 'No',
        }).then((result) => {
            if (result.isConfirmed) {
                const reset = this.resetHabitacion(habitacion);
                updateHabitacion(reset).then(() => {
                    deleteMessages(habitacion.idHabitacion).then((data) => {
                        this.toast.add({ severity: 'success', summary: 'Proceso Exitoso', detail: 'La habitación se liberó correctamente', life: 3600 });
                    });
                });
            }
        });
    }

    private resetHabitacion(habitacion: any) {
        habitacion.nombrePaciente = null;
        habitacion.edad = null;
        habitacion.direccion = null;
        habitacion.tel = null;
        habitacion.correo = null;
        habitacion.fechaNacim = null;
        habitacion.sexo = null;
        habitacion.estadoCivil = null;
        habitacion.fechaingreso = null;
        habitacion.diagnosticoi = null;
        habitacion.diagnosticoe = null;
        habitacion.nombreEnfermero = null;
        habitacion.medicoTratante = null;
        habitacion.isalergia = false;
        habitacion.alergias = [];
        habitacion.isdiabetico = false;
        habitacion.ishipertenso = false;
        habitacion.fechaing = null;
        habitacion.fechaegr = null;
        habitacion.status = 0;
        return habitacion;
    }
}
